// frontend/src/api/aiLogs.js
import { apiClient } from './index';

const aiLogsApi = {
  /**
   * Get list of users who have chatted, with session counts
   */
  getChatUsers: async () => {
    return await apiClient.get('/ai-logs/users');
  },

  /**
   * Get messages for a single session
   */
  getMessagesBySession: async (sessionId) => {
    return await apiClient.get(`/ai-logs/sessions/${sessionId}/messages`);
  },

  /**
   * Get ALL history for a user (for downloading)
   */
  getUserFullHistory: async (userId) => {
    return await apiClient.get(`/ai-logs/user/${userId}/full-history`);
  },

  /**
   * Bulk delete sessions
   * @param {Array} sessionIds 
   */
  deleteSessions: async (sessionIds) => {
    return await apiClient.delete('/ai-logs/delete', { body: { session_ids: sessionIds } });
  }
};

export { aiLogsApi };